var TestimonialsCarrousel = {
	init:function(){
	
		var latest_testimonials_carousel = $('.testimonials .testimonials-carousel').slick({
			centerMode: false,
			centerPadding: 0,
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite:true,
			arrows:false,
			dots:true,			
			appendDots: $('.testimonials-carousel-content .controls .carousel-dots'),
		});

		latest_testimonials_carousel.on('afterChange', function(){
			var index = Number($('.testimonials .testimonials-carousel .slick-slide.slick-current').data('slick-index'))+1;
			if(index < 10){
				index = "0" + index;
			}
			$('.testimonials-carousel-content .controls .counter .current').html(index);
		});


		$('.testimonials .controls .slick-prev').click(function(){
			latest_testimonials_carousel.slick('slickPrev');
			return false;
		});
		$('.testimonials .controls .slick-next').click(function(){
			latest_testimonials_carousel.slick('slickNext');
			return false;
		});
	}
};

